<template>
  <div>
    <b-button variant="primary" v-if="manage" v-b-modal.add-app-notifications>
      <span class="text-nowrap">Add Push Notification</span>
    </b-button>

    <b-modal id="add-app-notifications" hide-footer size="md" centered
      :title="isEditing ? 'Edit Push Notification' : 'Add Push Notification'" @hidden="resetModal">

      <div class="modal_content">
        <b-alert dismissible :show="hasError" class="p-1" variant="danger" @dismissed="clearErrorMsg">
          {{ errorMsg }}
        </b-alert>

        <p class="mb-0">Title <span class="text-danger">*</span></p>
        <b-form-input class="mb-1" v-model="record.title" placeholder="Add title here.." type="text" />


        <p class="mb-0">Message <span class="text-danger">*</span></p>
        <b-form-textarea class="mb-1" v-model="record.message" rows="6" placeholder="Enter a message"></b-form-textarea>


        <p class="mb-0">Mascot </p>
        <input ref="ref_Input_mascort" type="file" accept="image/*" class="d-none" @change="ImageRendererItems" />
        <b-dropdown v-if="!record.mascort" variant="link" no-caret>
          <template #button-content>
            <feather-icon icon="UploadIcon" size="50" class="qu-icon-grey curser-pointer" />
          </template>
          <b-dropdown-item @click="triggerFileInput()">
            <feather-icon icon="UploadIcon" /> Upload
          </b-dropdown-item>
          <b-dropdown-item @click="showGalleryImages">
            <feather-icon icon="ImageIcon" /> Gallery Images
          </b-dropdown-item>
        </b-dropdown>
        <template v-else>
          <img :src="record.mascort" height="80" :alt="record.mascort" @click="showImageInModel()" />
        </template>


        <div class="mb-2">
          <p class="mb-0">Users <span class="text-danger">*</span></p>
          <b-form-select class="mb-0" v-model="record.whenTrigger"
            :options="userOptionsWithPlaceholder"></b-form-select>
          <p v-if="record.whenTrigger === 'all'" style="font-size: 12px;">
            <template v-if="AllUsersCount === 0">
              No users found.
            </template>
            <template v-else-if="AllUsersCount === 1">
              <strong>1</strong> user found.
            </template>
            <template v-else>
              <strong>{{ AllUsersCount }}</strong> users found.
            </template>
          </p>
        </div>


        <div v-if="record.whenTrigger === 'specific_country'" class="mt-2 mb-2">
          <p class="mb-0">Select Country <span class="text-danger">*</span></p>

          <b-form-select class="mb-0" v-model="record.selectedCountry" :options="countryOptionsWithPlaceholder"
            @change="fetchCountryUserCount"></b-form-select>

          <p v-if="record.selectedCountry" style="font-size: 12px;">
            <template v-if="countryUserCount === 0">
              No user found in this country.
            </template>
            <template v-else-if="countryUserCount === 1">
              <strong>1</strong> user found in this country.
            </template>
            <template v-else-if="countryUserCount > 1">
              <strong>{{ countryUserCount }}</strong> users found in this country.
            </template>
          </p>
        </div>


        <div v-if="record.whenTrigger === 'specific_users'" class="mt-2">
          <p class="mb-0">Profile IDs <span class="text-danger">*</span></p>
          <b-form-input class="mb-2" v-model="record.specificUserIds"
            placeholder="Enter profile IDs (comma separated, e.g. 10427, 30519, 31650)" />
          <small class="text-muted mb-2"></small>
        </div>

        <div v-if="record.whenTrigger === 'active-users'" class="mt-2 mb-2">
          <p class="mb-0">Active Duration <span class="text-danger">*</span></p>
          <b-form-select class="mb-0" v-model="record.activeDuration" :options="activeDurationOptionsWithPlaceholder"
            @change="fetchActiveUserCount"></b-form-select>

          <p v-if="record.activeDuration" style="font-size: 12px;">
            <template v-if="activeUserCount === 0">
              No user found.
            </template>
            <template v-else-if="activeUserCount === 1">
              <strong>1</strong> active user found.
            </template>
            <template v-else-if="activeUserCount > 1">
              <strong>{{ activeUserCount }}</strong> active users found.
            </template>
          </p>

        </div>

        <div class="mb-1 ">
          <b-form-select v-if="record.whenTrigger === 'class'" class="mb-0" v-model="record.selectedClass"
            :options="classOptionsWithPlaceholder" @change="fetchClassUserCount"></b-form-select>

          <p v-if="record.selectedClass && record.whenTrigger === 'class'" style="font-size: 12px;">
            <template v-if="classUserCount === 0">
              No user found in this grade.
            </template>
            <template v-else-if="classUserCount === 1">
              <strong>1</strong> user found in this grade.
            </template>
            <template v-else-if="classUserCount > 1">
              <strong>{{ classUserCount }}</strong> users found in this grade.
            </template>
          </p>

        </div>

        <div class="d-flex align-items-center justify-content-between mb-0">

          <p class="mb-0">Schedule Time <span class="text-danger">*</span></p>
          <b-form-checkbox v-model="record.sendNow" switch class="ml-2" @change="toggleSendNow">
            Send Now
          </b-form-checkbox>
        </div>

        <input type="datetime-local" v-model="record.scheduled_at" class="form-control" :disabled="record.sendNow" />


        <div class="modal-footer">
          <b-button @click="isEditing ? updateNotification() : addNotification()" :disabled="loading" variant="primary">
            <b-spinner v-if="loading" small class="mr-1" />
            {{ isEditing ? "Update" : "Add" }}
          </b-button>

        </div>
      </div>
    </b-modal>


    <b-modal v-model="showFullScreen" size="lg">
      <b-button variant="primary" @click="triggerFileInput()">
        Upload
      </b-button>
      <b-button class="ml-1" variant="primary" @click="showGalleryImages">
        Gallery Images
      </b-button>
      <b-button v-if="record.mascort" class="ml-1" variant="danger" @click="removeImage">
        Remove
      </b-button>
      <div class="text-center mt-2">
        <img v-if="record.mascort" :src="record.mascort" alt="Fullscreen" style="height: auto; max-width: 100%" />
        <feather-icon v-else @click="triggerFileInput()" icon="UploadIcon" size="50"
          class="qu-icon-grey curser-pointer" />
      </div>
    </b-modal>
    <zape-gallery-model :props_hideShowModel="showImage" @modelClose="modelClose"
      @saveCategoryImage="saveCategoryImage" />
  </div>
</template>

<script>
import {
  BButton,
  BFormInput,
  BFormGroup,
  BAlert,
  BSpinner,
  BFormSelect,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormCheckbox

} from "bootstrap-vue";
import axios from "axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    ZapeGalleryModel: () => import("../../Model/ZapeGalleryModel.vue"),
    BButton,
    BFormInput,
    BFormGroup,
    BAlert,
    BSpinner,
    ToastificationContent,
    BFormSelect,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BFormCheckbox
  },
  data() {
    return {
      record: {
        whenTrigger: "",
        selectedClass: null,
        message: "",
        mascort: "",
        title: "",
        sendNow: false,
        users: "",
        className: "",
        scheduled_at: "",
        specificUserIds: "",
        activeDuration: null,
        selectedCountry: null,
      },
      activeDurationOptions: [
        { value: "today", text: "Today" },
        { value: "yesterday", text: "Yesterday" },
        { value: "this_month", text: "This Month" },
        { value: "last_month", text: "Last Month" },
        { value: "this_year", text: "This Year" },
      ],
      countries: [],    
      countryUserCount: null, 

      AllUsersCount: null,
      activeUserCount: null,
      isEditing: false,
      editingId: null,
      classUserCount: null,
      classOptions: [],
      userOptions: [
        { value: "all", text: "All Users" },
        { value: "active-users", text: "Active Users" },
        { value: "class", text: "Specific Class" },
        { value: "specific_users", text: "Specific Users" },
        { value: "specific_country", text: "Specific Country" },

      ],


      errorMsg: "",
      loading: false,
      alertMessageToast: "",

      showFullScreen: false,
      showImage: false,
    };
  },
  computed: {
    hasError() {
      return this.errorMsg != "";
    },

    countryOptionsWithPlaceholder() {
      return [{ value: null, text: "Select country", disabled: true }, ...this.countries];
    },


    activeDurationOptionsWithPlaceholder() {
      return [{ value: null, text: "Select duration", disabled: true }, ...this.activeDurationOptions];
    },

    userOptionsWithPlaceholder() {
      return [{ value: null, text: "Select user type", disabled: true }, ...this.userOptions];
    },
    classOptionsWithPlaceholder() {
      return [{ value: null, text: "Select grade", disabled: true }, ...this.classOptions];
    },

    formattedNotificationTypes() {
      return this.notificationTypes.map(item => ({
        value: item._id,
        text: item.name
      }));
    },
  },

  watch: {
    editRecord: {
      handler(newVal) {
        console.log('newVal', newVal)
        if (newVal && this.isEditingParent) {
          this.record = { ...newVal };
          this.isEditing = true;
          this.editingId = this.editingIdParent || null;
        } else {
          this.isEditing = false;
          this.editingId = null;
        }
      },
      deep: true,
      immediate: true,
    },

    'record.whenTrigger'(newVal) {
      this.activeUserCount = null;
      this.classUserCount = null;
      this.AllUsersCount = null;

      if (newVal !== 'active-users') {
        this.record.activeDuration = null;
        this.activeUserCount = null;
      }
      if (newVal !== 'class') {
        this.record.selectedClass = null;
        this.classUserCount = null;
      }

      if (newVal !== 'specific_users') {
        this.record.specificUserIds = "";
      }
      if (newVal !== 'specific_country') {
        this.record.selectedCountry = null;
        this.countryUserCount = null;
      }

      if (newVal === 'all') {
        this.fetchTotalUserCount();
      }
    },

  },



  mounted() {
    this.getAllGrades();
    this.getCountries();

  },
  methods: {

    async fetchCountryUserCount() {

      if (!this.record.selectedCountry) return;

      this.countryUserCount = null;

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/get-country-user-count`,
          {
            headers: {
              Authorization: this.token,
            },
            params: {
              countryCode: this.record.selectedCountry,
            },
          }
        );

        this.countryUserCount = res.data.count || 0;
      } catch (error) {
        console.error("❌ Error fetching user count by country:", error);
        this.countryUserCount = null;
      } finally {
        console.log("✅ Country user count fetched:", this.countryUserCount);
      }
    },




    async getCountries() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/countries`, {
          headers: {
            Authorization: this.token,
          },
        });

        if (Array.isArray(res.data)) {

          this.countries = res.data
            .filter(country => country.status === "active")
            .map(country => ({
              value: country.code,
              text: country.name,
              capital: country.capital,
              timezone: country.timezones?.[0] || null,
            }))
            .sort((a, b) => a.text.localeCompare(b.text));
        } else {
          console.warn("Unexpected response format:", res.data);
          this.countries = [];
        }

      } catch (error) {
        console.error("Error fetching countries:", error);
        this.countries = [];
      }
    },


    async fetchActiveUserCount() {
      if (!this.record.activeDuration) {
        this.activeUserCount = null;
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/get-active-users-count?duration=${this.record.activeDuration}`,
          { headers: { Authorization: this.token } }
        );

        console.log("✅ Active user count fetched:", res.data.count);
        this.activeUserCount = res.data.count || 0;
      } catch (error) {
        console.error("❌ Error fetching active user count:", error);
        this.activeUserCount = 0;
      }
    },

    async fetchTotalUserCount() {

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/get-all-user-count`,
          {
            headers: { Authorization: this.token },
          }
        );
        this.AllUsersCount = res.data.count;
      } catch (error) {
        console.error("❌ Error fetching class user count:", error);
        this.classUserCount = null;
      }


    },


    toggleSendNow() {
      if (this.record.sendNow) {

        const now = new Date();
        const localISOTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
          .toISOString()
          .slice(0, 16);
        this.record.scheduled_at = localISOTime;
      }
    },


    async getAllGrades() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_API_URL + "/get-all-grades",
          {
            headers: {
              Authorization: this.token,
            },
          }
        );

        this.classOptions = res.data;
        if (this.isEditing && this.editRecord?.selectedClass) {
          this.record.selectedClass = this.editRecord.selectedClass;
        }

      } catch (error) {
        console.error("❌ Error fetching classes:", error);
      }
    },

    async fetchClassUserCount() {
      if (!this.record.selectedClass) return;
      this.classUserCount = null;

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/get-grades-user-count?gradeId=${this.record.selectedClass}`,
          {
            headers: { Authorization: this.token },
          }
        );
        this.classUserCount = res.data.count;
      } catch (error) {
        console.error("❌ Error fetching class user count:", error);
        this.classUserCount = null;
      }
    },



    onChangeNotificationType() {
      this.record.whenTrigger = '';
    },
    getNotificationTypeName() {
      const result = this.notificationTypes.find(item => item._id === this.record.notificationType);
      return !result || result.name.toLowerCase() === 'active';
    },
    async ImageRendererItems(event) {
      const file = event.target.files[0];

      if (file) {
        const fileType = file.type;
        const fileExtension = this.getFileExtension(fileType);
        try {
          const response = await axios.post(
            process.env.VUE_APP_API_URL +
            "/s3/generate-presigned-url",
            {
              type: file.type,
              ext: fileExtension,
            },
            {
              headers: {
                Authorization: this.token,
              },
            }
          );
          const { url, key } = response.data;

          let extention =
            fileExtension == "json" ? "lottie" : fileExtension;
          await this.uploadFile(file, url, key, extention);
        } catch (error) {
          console.error("Error getting pre-signed URL:", error);
        }
      }
    },
    async uploadFile(file, url, key, ext) {
      try {
        const response = await axios.put(url, file, {
          headers: {
            Accept: "application/json",
            "Content-Type": file.type,
          },
        });

        if (response.status !== 200) {
          console.error("Error uploading file:", response);
        }
        let s3Url =
          "https://zape02.s3.ap-southeast-1.amazonaws.com/" + key;
        this.record.mascort = s3Url;
        this.createGalleryImage(s3Url, file.name, ext);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },
    async createGalleryImage(s3Url, fileName, ext) {
      try {
        let galleryObj = {
          name: fileName,
          url: s3Url,
          imageFormat: ext,
        };
        await axios.post(
          process.env.VUE_APP_API_URL + "/gallery/image/create",
          galleryObj,
          {
            headers: {
              Authorization: this.token,
            },
          }
        );
      } catch (error) {
        console.error("Error saving image to gallery", error);
      }
    },
    getFileExtension(mimeType) {
      const mimeToExtension = {
        "image/jpeg": "jpg",
        "image/png": "png",
        "image/gif": "gif",
        "application/json": "json",
        ".json": "json",
      };
      return mimeToExtension[mimeType] || "png";
    },

    showGalleryImages() {
      this.showImage = true;
    },
    modelClose(modelState) {
      this.showImage = modelState;
    },
    removeImage() {
      this.record.mascort = null;
    },
    saveCategoryImage(categoryImage) {
      this.record.mascort = categoryImage;
    },
    triggerFileInput() {
      this.$refs.ref_Input_mascort.click();
    },
    showImageInModel() {
      this.showFullScreen = true;
    },
    showToast(variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.alertMessageToast,
          variant,
        },
      });
    },
    clearErrorMsg() {
      this.errorMsg = "";
    },
    resetModal() {
      this.record = {
        whenTrigger: "",
        selectedClass: null,
        message: "",
        mascort: "",
        title: "",
        sendNow: false,
        users: "",
        className: "",
        scheduled_at: "",
        specificUserIds: "",
        activeDuration: null,
        selectedCountry: null,
      };
      this.errorMsg = "";
      this.isEditing = false;
      this.activeUserCount = null;
      this.AllUsersCount = null;
      this.classUserCount = null;
      this.countryUserCount = null;
    },



    async addNotification() {
      this.errorMsg = "";
      const status = this.checkValidation();
      if (!status) return;

      this.loading = true;

      try {

        if (this.record.sendNow) {
          this.record.scheduled_at = new Date().toISOString();
        }

        const resp = await axios.post(
          process.env.VUE_APP_API_URL + "/push-notification/create",
          this.record,
          {
            headers: {
              Authorization: this.token,
            },
          }
        );

        if (resp.data.success) {
          this.alertMessageToast = "Notification created successfully!";
          this.showToast("success");
          this.$emit("fetchNotifications");
          this.$bvModal.hide("add-app-notifications");
        }
      } catch (error) {
        if (error.response) {
          this.errorMsg = error.response.data.error || "An error occurred";
        } else if (error.request) {
          this.errorMsg =
            "No response received from server. Please check your network connection.";
        } else {
          this.errorMsg = "Error in request setup: " + error.message;
        }

        this.alertMessageToast = this.errorMsg;
        this.showToast("danger");
      } finally {
        this.loading = false;
      }
    },

    async updateNotification() {
      this.errorMsg = "";
      const status = this.checkValidation();
      if (!status) return;

      this.loading = true;

      try {

        if (this.record.sendNow) {
          this.record.scheduled_at = new Date().toISOString();
        }

        const resp = await axios.put(
          `${process.env.VUE_APP_API_URL}/push-notification/update/${this.editingId}`,
          this.record,
          {
            headers: { Authorization: this.token },
          }
        );

        if (resp.data.success) {
          this.alertMessageToast = "Notification updated successfully!";
          this.showToast("success");
          this.isEditing = false;
          this.$emit("fetchNotifications");
          this.$bvModal.hide("add-app-notifications");
        }
      } catch (error) {
        if (error.response) {
          this.errorMsg = error.response.data.error || "An error occurred";
        } else if (error.request) {
          this.errorMsg = "No response from server. Please check your network.";
        } else {
          this.errorMsg = "Error in request setup: " + error.message;
        }

        this.alertMessageToast = this.errorMsg;
        this.showToast("danger");
      } finally {
        this.loading = false;
      }
    },



    checkValidation() {
      if (!this.record.title || !this.record.title.trim()) {
        this.errorMsg = "Title is required.";
        return false;
      }

      if (!this.record.message || !this.record.message.trim()) {
        this.errorMsg = "Message is required.";
        return false;
      }


      if (!this.record.whenTrigger) {
        this.errorMsg = "User type is required.";
        return false;
      }

      if (this.record.whenTrigger === "class" && !this.record.selectedClass) {
        this.errorMsg = "Class is required when User type is 'class'.";
        return false;
      }

      return true;
    },

  },
  props: ["manage", "token", "notificationTypes", "editRecord", "isEditingParent", "editingIdParent"],

};
</script>
